import { Simulation } from "../../pkg";

import * as classes from "./Game.module.css";
import { SimulationCanvas } from "./SimulationCanvas";
import { useEffect, useRef, useState } from "react";
import { UpgradeButton } from "./UpgradeButton";
import { Num } from "./Num";

interface GameProps {
    simulation: Simulation;
}

export function Game(props: GameProps) {
    const { simulation } = props;

    const [paused, setPaused] = useState(false);
    const pausedRef = useRef(paused);
    pausedRef.current = paused;

    const [spice, setSpice] = useState(0);

    useEffect(() => {
        function handleKeypress(e: KeyboardEvent) {
            if (e.code === "Space") {
                setPaused((paused) => !paused);
            }
        }

        window.addEventListener("keypress", handleKeypress);
        return () => {
            window.removeEventListener("keypress", handleKeypress);
        };
    }, []);

    useEffect(() => {
        let lastUpdateTime = performance.now();

        function update() {
            const time = performance.now();
            const dt = time - lastUpdateTime;
            lastUpdateTime = time;

            if (!pausedRef.current) {
                const updateResult = simulation.update(dt, undefined);
                setSpice((spice) => spice + updateResult.sand_consumed);
            }
        }

        const intervalId = window.setInterval(update, 10);

        return () => {
            window.clearInterval(intervalId);
        };
    }, []);

    return (
        <div className={classes.root}>
            <div className={classes.sidebarContainer}>
                <h1>
                    <Num value={spice} unit=" Spice" />
                </h1>
                <div className={classes.upgradesContainer}>
                    <div className={classes.upgradesHeader}>
                        <span>Upgrade</span>
                        <span>Reward</span>
                        <span>Cost</span>
                    </div>
                    <UpgradeButton
                        name="Decrease Cooldown"
                        category="Manual Thumper"
                        categoryHsl="177 45% 39%"
                        valueCurrent={<Num value={1} unit="s" />}
                        valueNext={<Num value={0.95} unit="s" />}
                        cost={<Num value={50} unit=" Spice" />}
                        disabled={spice < 50}
                    />
                    <UpgradeButton
                        name="Increase Lure Chance"
                        category="Manual Thumper"
                        categoryHsl="177 45% 39%"
                        valueCurrent={<Num value={20} unit="%/tap" />}
                        valueNext={<Num value={25} unit="%/tap" />}
                        cost={<Num value={128} unit=" Spice" />}
                        disabled={spice < 128}
                    />
                    <UpgradeButton
                        name="Decrease Cooldown"
                        category="Manual Sand Dropper"
                        categoryHsl="30 60% 50%"
                        valueCurrent={<Num value={1} unit="s" />}
                        valueNext={<Num value={0.95} unit="s" />}
                        cost={<Num value={20} unit=" Spice" />}
                        disabled={spice < 20}
                    />
                    <UpgradeButton
                        name="Increase Dimensions"
                        category="Sandbox"
                        categoryHsl="237 60% 65%"
                        valueCurrent={<Num value={128} unit="px²" />}
                        valueNext={<Num value={196} unit="px²" />}
                        cost={<Num value={20} unit=" WoL" />}
                        disabled
                    />
                </div>
            </div>
            <div className={classes.canvasContainer}>
                <SimulationCanvas simulation={simulation} />
            </div>
        </div>
    );
}
